import { useEffect } from "react";
import ReactGA from "react-ga";

export default () => {
  useEffect(() => {
    ReactGA.initialize("UA-143620058-1", { debug: false });
  }, []);
  return null;
};
